import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageLayout from '../../components/common/PageLayout';
import DownloadReportModal from '../../components/modals/DownloadReportModal';
import { RetailerDropshipOrdersPanel } from '../../components/pages/RetailerDropshipOrders/RetailerDropshipOrdersPanel';
import DropshipOrdersContainer from '../blocks/DropshipOrdersContainer';
import { dropshipOrdersReportClose } from '../../store/actions/dropshipOrders';

export default function DropshipOrdersPageContainer() {
  const dispatch = useDispatch();
  const { isReport } = useSelector((state) => state.dropshipOrders);

  return (
    <PageLayout top={<RetailerDropshipOrdersPanel />}>
      <DownloadReportModal open={isReport} onClose={() => dispatch(dropshipOrdersReportClose())} />
      <DropshipOrdersContainer />
    </PageLayout>
  );
}
